import {compose, defaultTo, join} from 'ramda';

import {getProperty} from 'libs/utils/utils';

/**
 * Return gender list from frame
 * @type {Function}
 * @param {SimpleProductType | QuoteItemType} quote item
 * @return {string} list of genders
 */
export const getGender = compose(join(','), defaultTo([]), getProperty('gender'));
